import gql from 'graphql-tag';

export class FormInput {
  id: number;
  name: string;
  ekaCodeValues: string;
  defEkaCode: string;
  unClassValues: string;
  defUnClass: string;
  useInProduction: boolean;
  isActive: boolean;
  isHazardous: boolean;
  notes: string;

  constructor() {
    this.id = undefined;
    this.name = undefined;
    this.ekaCodeValues = undefined;
    this.defEkaCode = undefined;
    this.unClassValues = undefined;
    this.defUnClass = undefined;
    this.useInProduction = undefined;
    this.isActive = undefined;
    this.isHazardous = undefined;
    this.notes = undefined;
  }
}

export const gqlGetQuery = gql`
  query getMaterials($limit: Int, $offset: Int, $order: String, $where: String) {
    getMaterials(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
        isHazardous
        ekaCodeValues
        unClassValues
        defEkaCode
        defUnClass
        notes
        useInProduction
        firstDate
        firstUser
        isActive
        lastDate
        lastUser
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getMaterialById($id: Int) {
    getMaterialById(id: $id) {
      id
      name
      isHazardous
      ekaCodeValues
      unClassValues
      notes
      useInProduction
      firstDate
      firstUser
      isActive
      lastDate
      lastUser
    }
  }
`;

export const gqlAdd = gql`
  mutation addMaterialType($data: MaterialInput) {
    addMaterial(data: $data) {
      id
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateMaterial($data: MaterialInput) {
    updateMaterial(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteMaterial($id: Int) {
    deleteMaterial(id: $id)
  }
`;
